module.exports = __webpack_public_path__ + "img/Stars_m.f247ba69.png";